import { initGuestGroupForms } from './_guest-group-form.js';
import { ShowMenuMovil } from './_menu.js';
import { QuitSession, ToggleShowwPass, fillFormDates, ValidateSendDates, deleteUser } from './_form.js';
import { initSortableTables } from './_table-sort.js';
import { initTableFilters } from './_table-filter.js';
import { initMailingSections } from './_mailing-sections.js';

window.fillFormDates        = fillFormDates;
window.deleteUser           = deleteUser;

document.addEventListener('DOMContentLoaded', () => {
    initGuestGroupForms();
    initSortableTables();
    initTableFilters();
    initMailingSections();

    document.getElementById('Navicon')?.addEventListener('click', ShowMenuMovil);

    document.querySelectorAll('.admin-menu__quit, .js-quit-session').forEach(el => {
        el.addEventListener('click', QuitSession);
    });

    document.querySelectorAll('.form-field__toggle[data-target]').forEach(btn => {
        btn.addEventListener('click', event => ToggleShowwPass(event, btn.dataset.target));
    });

    document.querySelectorAll('form[data-prefix]').forEach(form => {
        form.addEventListener('submit', event => {
            ValidateSendDates(event, form.id, form.dataset.prefix, form.dataset.action || '');
        });
    });

    document.querySelectorAll('.js-btn-back').forEach(btn => {
        btn.addEventListener('click', () => history.back());
    });

    document.querySelectorAll('[data-copy-invitation-url]').forEach(button => {
        button.addEventListener('click', async () => {
            const feedback = button.closest('.invitation-qr-card')?.querySelector('.invitation-qr-card__feedback');
            try {
                if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
                await navigator.clipboard.writeText(button.dataset.copyInvitationUrl);
                if (feedback) feedback.textContent = 'Enlace copiado.';
            } catch {
                if (feedback) feedback.textContent = 'Selecciona el enlace para copiarlo.';
                button.closest('.invitation-qr-card')?.querySelector('input[readonly]')?.select();
            }
        });
    });

});
